/**
 * Platform detection utilities.
 *
 * navigator.platform is deprecated and returns empty or incorrect values in
 * modern browsers. Use navigator.userAgentData?.platform when available; fall
 * back to a regex match against navigator.platform || navigator.userAgent so
 * the result is correct across all modern environments.
 */

/**
 * Returns true when the current platform is macOS, iOS, or iPadOS.
 * Used for keyboard shortcut detection (Cmd vs Ctrl).
 */
export function isMacPlatform(): boolean {
  // Prefer the newer userAgentData API (Chrome 90+, Edge 90+).
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const uaDataPlatform: string | undefined = (navigator as any).userAgentData?.platform;
  if (uaDataPlatform) {
    return /mac/i.test(uaDataPlatform);
  }
  // Fall back to legacy navigator.platform first, then navigator.userAgent.
  const source = navigator.platform || navigator.userAgent;
  return /(Mac|iPhone|iPad|iPod)/i.test(source);
}
